export enum LanguageCode {
	Fr = "Fr",
	En = "En"
}

/**
 * Normalises any language string to a canonical {@link LanguageCode}. The app mixes casings —
 * i18n uses lowercase ("fr"/"en"), the enum and every `values`/flags key are capitalised
 * ("Fr"/"En") — and comparing across them silently breaks: a hook keyed on "Fr" but read with a
 * lowercase "fr" returns undefined (empty fields), and a save routes to the wrong language. Always
 * funnel external language strings through this before using them as a LanguageCode.
 */
export const toLanguageCode = (value: string | null | undefined): LanguageCode =>
	value?.toLowerCase() === "en" ? LanguageCode.En : LanguageCode.Fr;
